import {RouteProps} from 'config/navigation';

import Companies from './companies';
import CreateCompany from './create-company';
import CompanyDetails from './company-details';
import CreateWorkingPeriod from './company-details/components/create-working-period';
import {FaBuilding} from 'react-icons/fa';
import CreateAccessControl from './company-details/components/create-access-control';
import CreateCompanyDistance from './company-details/components/create-company-distance';
import CreateNeighborhoodPrice from './company-details/components/create-neighborhood-price';
import EditNeighborhoodPrice from './company-details/components/edit-neighborhood-price';
import AwaitingApprovalCompanies from './awaiting-approval-companies';

const companiesPages: RouteProps = {
  name: 'Empresas',
  path: 'companies',
  permission: 'companies.findAll',
  icon: <FaBuilding />,
  subRoutes: [
    {
      path: '',
      element: <Companies />,
      permissions: ['companies.findAll'],
    },
    {
      path: 'create',
      element: <CreateCompany />,
      permissions: ['companies.create'],
    },
    {
      path: ':id',
      element: <CompanyDetails />,
      permissions: ['companies.findOne'],
    },
    {
      path: ':id/working-periods',
      element: <CompanyDetails activeTab="working-periods" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateWorkingPeriod />,
          title: 'Cadastrar horário de funcionamento',
        },
      ],
    },
    {
      path: ':id/access-controls',
      element: <CompanyDetails activeTab="access-controls" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateAccessControl />,
          title: 'Cadastrar controle de acesso',
        },
      ],
    },
    {
      path: ':id/distances',
      element: <CompanyDetails activeTab="distances" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateCompanyDistance />,
          title: 'Cadastrar distância',
        },
      ],
    },
    {
      path: ':id/neighborhood-prices',
      element: <CompanyDetails activeTab="neighborhood-prices" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: ':companyNeighborhoodPriceId',
          element: <EditNeighborhoodPrice />,
          title: 'Editar bairro',
        },
        {
          path: 'create',
          element: <CreateNeighborhoodPrice />,
          title: 'Cadastrar bairro',
        },
      ],
    },
  ],
};

const awaitingApprovalCompaniesPages: RouteProps = {
  name: 'Empresas pendentes',
  path: 'awaiting-approval-companies',
  permission: 'companies.findAll',
  icon: <FaBuilding />,
  subRoutes: [
    {
      path: '',
      element: <AwaitingApprovalCompanies />,
      permissions: ['companies.findAll'],
    },
  ],
};

const myCompaniesPages: RouteProps = {
  name: 'Minha empresa',
  path: 'companies',
  permission: 'companies.findOne',
  icon: <FaBuilding />,
  hidden: true,
  addCompanyUrl: true,
  subRoutes: [
    {
      path: ':id',
      element: <CompanyDetails />,
      permissions: ['companies.findOne'],
    },
    {
      path: ':id/working-periods',
      element: <CompanyDetails activeTab="working-periods" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateWorkingPeriod />,
          title: 'Cadastrar horário de funcionamento',
        },
      ],
    },
    {
      path: ':id/access-controls',
      element: <CompanyDetails activeTab="access-controls" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateAccessControl />,
          title: 'Cadastrar controle de acesso',
        },
      ],
    },
    {
      path: ':id/distances',
      element: <CompanyDetails activeTab="distances" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: 'create',
          element: <CreateCompanyDistance />,
          title: 'Cadastrar distância',
        },
      ],
    },
    {
      path: ':id/neighborhood-prices',
      element: <CompanyDetails activeTab="neighborhood-prices" />,
      permissions: ['companies.findOne'],
      modals: [
        {
          path: ':companyNeighborhoodPriceId',
          element: <EditNeighborhoodPrice />,
          title: 'Editar bairro',
        },
        {
          path: 'create',
          element: <CreateNeighborhoodPrice />,
          title: 'Cadastrar bairro',
        },
      ],
    },
  ],
};

export default [myCompaniesPages];
